import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import index from '@/components/index'
import fuHAdd from '@/components/fuHAdd'
import fenGAdd from '@/components/fenGAdd'
import caiQAdd from '@/components/caiQAdd'

Vue.use(Router);

// export default new Router({
//   routes: [
//     {
//       path: '/',
//       name: 'login',
//       component: login
//     }
//   ]
// })


// 路由配置
const RouterConfig = {
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/fuHAdd',
      name: 'fuHAdd',
      component: fuHAdd
    },
    {
      path: '/fenGAdd',
      name: 'fenGAdd',
      component: fenGAdd
    },
    {
      path: '/caiQAdd',
      name: 'caiQAdd',
      component: caiQAdd
    }
  ]
};
export const router = new Router(RouterConfig);



// WEBPACK FOOTER //
// ./src/router/index.js